import envConfig from '../__env__/envConfig';

const defaultConfig = {
    environment: 'DEVELOPMENT', // PRODUCTION, DEVELOPMENT
};

const bootstrapConfig = Object.assign(defaultConfig, envConfig);

export default bootstrapConfig;
